module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/fiatrejectconfirm/fiatwithdrawrejectconfirm.component.css
// module id = ./src/app/fiatrejectconfirm/fiatwithdrawrejectconfirm.component.css
// module chunks = main